import { RoutePathsType } from "../types/routePaths";

export const RoutePaths: RoutePathsType = {
  NavBar: {
    primaryLinks: [
      {
        name: "Parenting",
        url: "/parenting",
      },
      {
        name: "Family Life",
        url: "/family",
      },
      {
        name: "Your Life",
        url: "/your-life",
      },
      {
        name: "Food",
        url: "/food",
      },
      {
        name: "Shopping",
        url: "/shopping",
      },
    ],
    searchBarLink: {
      name: "Search",
      url: "/search",
    },
    utilityLinks: [],
  },
  Footer: [
    {
      text: "About Us",
      url: "/about-us",
    },
    {
      text: "Contact Us",
      url: "https://www.sph.com.sg/contact-us/?ctopic=advertising",
      target: "_blank",
    },
    {
      text: "Advertise with us",
      url: "https://www.sph.com.sg/advertising-solutions/",
      target: "_blank",
    },
    {
      text: "PDPA",
      url: "https://www.sph.com.sg/legal/pdpa/",
      target: "_blank",
    },
    {
      text: "Terms and Conditions",
      url: "https://www.sph.com.sg/legal/website_tnc/",
      target: "_blank",
    },
    {
      text: "Privacy Statement",
      url: "https://www.sph.com.sg/legal/sph_privacy/",
      target: "_blank",
    },
  ],
  MegaMenu: [
    {
      text: "Parenting",
      url: "/parenting",
      placement: "left",
      subMenu: [
        {
          text: "Pregnancy",
          url: "/tag/pregnancy",
        },
        {
          text: "Postpartum",
          url: "/tag/postpartum",
        },
        {
          text: "Baby",
          url: "/tag/baby",
        },
        {
          text: "Toddler",
          url: "/tag/toddler",
        },
        {
          text: "Preschool",
          url: "/tag/preschool",
        },
        {
          text: "Primary School",
          url: "/tag/primary-school",
        },
      ],
    },
    {
      text: "Family Life",
      url: "/family",
      placement: "right",
      subMenu: [
        {
          text: "Things To Do",
          url: "/tag/things-to-do",
        },
        {
          text: "Marriage",
          url: "/tag/marriage",
        },
        {
          text: "Home",
          url: "/tag/home",
        },
      ],
    },
    {
      text: "Your Life",
      url: "/your-life",
      placement: "left",
      subMenu: [
        {
          text: "Entertainment",
          url: "/tag/entertainment",
        },

        {
          text: "Beauty",
          url: "/tag/beauty",
        },

        {
          text: "Wellness",
          url: "/tag/wellness",
        },

        {
          text: "Travel",
          url: "/tag/travel",
        },
        {
          text: "Career",
          url: "/tag/career",
        },
      ],
    },
    {
      text: "Food",
      url: "/food",
      placement: "right",
      subMenu: [
        {
          text: "Eating Out",
          url: "/tag/eating-out",
        },
        {
          text: "Recipes",
          url: "/tag/recipes",
        },
        {
          text: "Festive Food",
          url: "/tag/festive-food",
        },
      ],
    },
    {
      text: "Shopping",
      url: "/shopping",
      placement: "right",
      subMenu: [
        {
          text: "Deals",
          url: "/tag/deals",
        },
      ],
    },
  ],
};
